module.exports = __webpack_public_path__ + "static/media/PublicSans-Regular.a18a5351.woff";